import { render } from "./FacebookPublicMessaging.vue?vue&type=template&id=5d7a085a&scoped=true"
import script from "./FacebookPublicMessaging.vue?vue&type=script&lang=js"
export * from "./FacebookPublicMessaging.vue?vue&type=script&lang=js"

import "./FacebookPublicMessaging.vue?vue&type=style&index=0&id=5d7a085a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d7a085a"]])

export default __exports__